var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('NavBar'),_c('router-view',{staticClass:"router-slot"}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }